<template>
    <ContainerWithMenu>
        <div class="page-content">
            <div class="row margin-bottom-20">
                <div class="col-xs-12 col-md-5">
                    <h1 class="h2 margin-0">{{ $t('views.reservations.title') }}</h1>
                </div>
                <div class="col-xs-12 col-md-7 text-right">
                    <button
                            class="btn btn-primary btn-action-mobile"
                            @click="newReservationModalVisible = true"
                    >
                        <i class="las la-calendar-plus"></i>
                        <span class="button-text">{{ $t('views.reservations.new') }}</span>
                    </button>
                </div>
            </div>
            <div class="table-responsive" v-if="reservations.length > 0">
                <ReservationTable :reservations="reservations"></ReservationTable>
            </div>
            <div v-else>
                <span class="text-muted">{{ $t('views.reservations.not_found') }}</span>
            </div>
            <div class="text-center">
                <Pagination
                        v-show="numberPagesReservation > 1"
                        :page-count="numberPagesReservation"
                        :click-handler="paginateCallback" />
            </div>
        </div>
        <NewReservationModal v-show="newReservationModalVisible"
                             :visible="newReservationModalVisible"
                             @success-new-reservation="onSuccessNewReservation"
                             @close-new-reservation-modal="newReservationModalVisible=false"></NewReservationModal>
        <SpinnerLoader v-show="loading"></SpinnerLoader>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";
    import ReservationTable from "../components/reservation/ReservationTable";
    import {getReservations} from "../api";
    import {LIMIT_RECORDS_API} from "../common/constants";
    import {Utils} from "../common/utils";
    import NewReservationModal from "../components/modal/NewReservationModal";
    import SpinnerLoader from "../components/common/SpinnerLoader";
    import Pagination from "../components/common/Pagination";
    import i18n from '../i18n'

    export default {
        title: i18n.t('views.reservations.title'),
        name: "Reservations",
        components: { ReservationTable, ContainerWithMenu, NewReservationModal, SpinnerLoader, Pagination},
        data: function() {
            return {
                reservations: [],
                countReservation: 0,
                limitReservation: LIMIT_RECORDS_API,
                currentPageReservation: 1,
                loading: false,
                newReservationModalVisible: false
            };
        },
        mounted() {
            this.getReservations()
        },
        computed: {
            numberPagesReservation: function () {
                return Utils.getNumberPageByCountLimit(this.countReservation, this.limitReservation);
            }
        },
        methods: {
            onSuccessNewReservation() {
                this.getReservations(0);
                this.newReservationModalVisible = false
            },
            paginateCallback(pageNum) {
                this.getReservations(pageNum)
            },
            async getReservations(page = 1) {
                this.loading = true;
                try {
                    let reservationsResponse = await getReservations(page);
                    this.countReservation = reservationsResponse.count;
                    this.reservations = reservationsResponse.results;

                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
        }
    };
</script>
